import { PagedResult } from '../../../shared/model/paged-result.model';
import { Invoice } from './invoice.model';

export class InvoiceSearchResult extends PagedResult {
  public constructor() {
    super();
    this.Result = new Array<Invoice>();
  }

  public Result: Array<Invoice>;
}
